// Dependencies
import ReferencesSlider from 'slider';


class References {
  /**
   * Constructor: Hero Constructor.
   */
  constructor(options = {}) {
    // Context
    this._context = options.context || document;

    // Root
    this._root = this._context.querySelector('[type="references"]');
    
    // Elements
    this._cards = [...this._root.querySelectorAll('.reference-card')];
    this._grid  = this._root.querySelector('.references__grid');
    this._nav   = this._root.querySelector('.references__nav');
    this._prev  = this._root.querySelector('.references__prev');
    this._next  = this._root.querySelector('.references__next');

    // Slider Class
    this.Slider = new ReferencesSlider({
      root   : this._root,
      grid   : this._grid,
      nodes  : this._cards,
      nav    : this._nav,
      buttons: {
        prev: this._prev,
        next: this._next,
      },
    });
  }


  /**
   * Resize: Resize the Cases.
   */
  resize() {
    this.Slider.resize();
  }
}

export default References;


// WEBPACK FOOTER //
// ./src/js/layouts/references/index.js